import React from "react";

const TermsAndCondition = () => {
  return (
    <div className="container my-5" style={{ maxWidth: "70%" }}>
      <h1 className="mb-4 fw-bold">Terms and Conditions</h1>

      <p>
        These Terms and Conditions (“Terms”) govern your use of our consulting services and website. By accessing our services, you agree to comply with and be legally bound by these Terms. If you do not agree to these Terms, please do not use our services.
      </p>

      <h5 className="mt-4 mb-2">1. Services Provided</h5>
      <p>
        We provide consulting services, digital strategy sessions, and expert advice related to your business or personal projects. All consultations are conducted online unless otherwise agreed upon. The scope and timeline of the services will be defined in a separate agreement or as agreed through email or booking forms.
      </p>

      <h5 className="mt-4 mb-2">2. Client Responsibilities</h5>
      <p>
        You agree to provide accurate, current, and complete information necessary for effective consultation. You are responsible for any decisions or actions taken based on our advice. We do not guarantee any specific business outcomes.
      </p>

      <h5 className="mt-4 mb-2">3. Payment and Billing</h5>
      <p>
        All services are billed in advance unless otherwise agreed. Payments must be made via the accepted payment methods listed on our website. If payment is not received on time, services may be suspended or cancelled.
      </p>

      <h5 className="mt-4 mb-2">4. Cancellation & Refund Policy</h5>
      <p>
        You may cancel a session with at least 24 hours' notice for a full refund or reschedule. Cancellations made less than 24 hours in advance are non-refundable. We reserve the right to cancel a session with full refund in case of emergency or conflict.
      </p>

      <h5 className="mt-4 mb-2">5. Confidentiality</h5>
      <p>
        We respect the confidentiality of your information. All discussions and materials shared during consultations will be treated as confidential and will not be disclosed to any third party without your consent, except as required by law.
      </p>

      <h5 className="mt-4 mb-2">6. Intellectual Property</h5>
      <p>
        All materials provided to you during or after the consulting sessions (documents, reports, strategies, tools) are owned by us unless stated otherwise. You may use them for your personal or business use, but not for resale, distribution, or public display without written permission.
      </p>

      <h5 className="mt-4 mb-2">7. Limitation of Liability</h5>
      <p>
        Our advice is based on the information you provide and our best judgment. We are not liable for any indirect, incidental, or consequential damages that may result from the use of our services. You agree to use our services at your own risk.
      </p>

      <h5 className="mt-4 mb-2">8. Termination</h5>
      <p>
        We reserve the right to terminate or suspend access to our services at our sole discretion if you violate these Terms. You may also discontinue services at any time; however, refunds are only provided in accordance with our cancellation policy.
      </p>

      <h5 className="mt-4 mb-2">9. Governing Law</h5>
      <p>
        These Terms shall be governed by and interpreted in accordance with the laws of your local jurisdiction, without regard to its conflict of law principles.
      </p>

      <h5 className="mt-4 mb-2">10. Contact Information</h5>
      <p>
        If you have any questions about these Terms and Conditions or need further assistance, please contact us at{" "}
        <a href="mailto:support@consultly.com" className="text-primary">support@consultly.com</a>.
      </p>
    </div>
  );
};

export default TermsAndCondition;
